import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchError } from './commonSlice';

const initialState = {
  list: [],
  perPage: '',
  total: '',
  loading: false,
  errorMessage: '',
};

export const getStoreUserList = createAsyncThunk('get-store-user', async (data, { dispatch }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}client/user/list`, { params: data });
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const createStoreUser = createAsyncThunk('create-store-user', async (data, { dispatch }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}client/user`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const editStoreUser = createAsyncThunk('edit-store-user', async (id, { dispatch }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}client/user/${id}`);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const updateStoreUser = createAsyncThunk('update-store-user', async ({ id, data }, { dispatch }) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}client/user/${id}`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const deleteStoreUser = createAsyncThunk('delete-store-user', async (id, { dispatch }) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}client/user/${id}`);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});


const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStoreUserList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStoreUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.UserList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
        state.errorMessage = '';
      })
      .addCase(getStoreUserList.rejected, (state, action) => {
        state.loading = false;
        state.list = '';
        state.perPage = '';
        state.total = '';
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(editStoreUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStoreUser.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(editStoreUser.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(updateStoreUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStoreUser.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(updateStoreUser.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(deleteStoreUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteStoreUser.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(deleteStoreUser.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(createStoreUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(createStoreUser.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(createStoreUser.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });
  },
});

export default userSlice.reducer;
